import { detectionChineseType } from 'json/lab-order'
export let filterFactor = [ {
  label: '类型',
  type: 'select',
  clearable: true,
  value: 'type', // 需返回数据的字段名
  options: getTypes()
}, {
  label: '所属知识库',
  type: 'select',
  clearable: true,
  value: 'corpusName',
  options: [
    {
      label: 'ASA成人基因检测',
      value: 'ASA成人基因检测'
    },
    {
      label: 'ASA儿童基因检测',
      value: 'ASA儿童基因检测'
    }
  ]
}]
export let tableLabels = [{
  label: '报告展示名称',
  value: 'chineseName'
}, {
  label: '所属检测项',
  value: 'detectionItemNameCn'
}, {
  label: '所属知识库',
  value: 'corpusName'
}, {
  label: '类型',
  value: 'type'
}, {
  label: '创建人',
  value: 'operationInformation.name',
  minWidth: '120'
}]
function getTypes () {
  let options = []
  detectionChineseType.forEach(item => {
    let signalItem = {
      label: item.value,
      value: item.key
    }
    options.push(signalItem)
  })
  return options
}
